var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInactiveSignatureCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-6h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0033AD",
    fillRule: "nonzero",
    d: "M6.667 4h30V.667h-30A3.343 3.343 0 0 0 3.333 4v18.333H0v5h23.333v-5H6.667V4zm31.666 3.333h-10c-.916 0-1.666.75-1.666 1.667v16.667c0 .916.75 1.666 1.666 1.666h10c.917 0 1.667-.75 1.667-1.666V9c0-.917-.75-1.667-1.667-1.667zm-1.666 15H30V10.667h6.667v11.666z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInactiveSignatureCollection);
export default __webpack_public_path__ + "static/media/ic_inactive_signature-collection.5374893c4361719c68e130d6e61c1a14.svg";
export { ForwardRef as ReactComponent };